var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0_291_1605)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_291_1605",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_291_1605",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_291_1605",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACu0lEQVR4nO2dvWoVURRGpxIFRUELG1utrQW1sLdRC/EFtLG09DaKtT+FiEUK3yKISPIG4z3fNyEMpBEbNWJhFxkTNYabZO78ZI+ZtWC6THJmfefM2WdfuMkyAAAAAAAA+IOkW7aXJa1L+iDpUVmWR//+BPSGpIe2N3Zekt7neX68v78Mme3JLPnbruWU0onocY5V/gYhxMsnhAHIJ4QByCeEAcgnhDZIetBRAITQFEIYAIRwuPaDXydm2hbxITxuMobRo45eR1UDL/pZhjSrJw3uaRvAejZ2/K/Igw5hKRszni3wwEJIKd3Ixor3Ftd7CNXnCdlYcT1hT/ramJHv2jO18xCQ77nf1Z2FgHw3rlZah4B8tyoXW4WAfLeW36Y6muueQ4W7ld9oJYwW9yOfEAYgnxAGIJ8QBiCfEAYgnxAGIJ8638iPwciPw8iPw8iPw8iPw8iPw8iPw8iPw8iPw8iPA/mBID8Q5AeC/ECQHwjyA0F+IMgPBPmBID8Q5AeT5/mR6XR6XtJNSQuSvhxgAJPo5x8cZVmesv0K+cH0HMIk+vn+i5Ug6SvyA5H0hg03EEl3mPmBFEVxkZkfiKQzkn4w8zugKIrbki41uXdlZeWcpOu2X9v+jPwGSHpq+1vTEH6zurp6smaJivzt2F7cEtM6hIp9QkD+Tmx/3CaodQjl5jlhVtsC+TuZTqenZ4j6nlK62ub3Slqg2qmB7cu7vCparQRt/sMEZv5+SLq7x/u68UpIKV1g5tdA0rN9KpZGK2Ftbe0YM78Gtt/WKBtb7wmwC5I+1Tw4EUIf7YQ5WweE0CVFUVxp0L8hhK6QdK9hE40QusD28znFVyfmxap3VDXwOhnEmJH0bhfRVVdzSdLLlNJ929fyPD8bPd5DR/WN4Ftl6IvqQFbtCdXGHD0uAAAAAAAAAACAbOD8BNkrVEMyfNt6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.ca134ec3d22bc90c721184b42f369fdc.svg";
export { ForwardRef as ReactComponent };